import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { checkValid, setValueForm, updateValidate } from '../../../../../helpers/form/FormHelper'
import { responseError } from '../../../../../helpers/response/ResponseHelper'
import { formDataProductIsField, formDataProductRequiredField } from '../../../../../helpers/form/FormData'
import ErrorMessage from '../../../../UI/messages/ErrorMessage'
import MyButton from '../../../../UI/form/MyButton'
import AgreeSelectMain from '../../../../form/fields/AgreeSelectMain'
import { agreeSupplyBillItemHeaderAPI } from '../../../../../api/supply/supplyBillItemAPI'
import { useDispatch } from 'react-redux'
import { editSupplyBillItem, editSupplyBillsItemsAllItem } from '../../../../../store/supplyBillSlice'
import DisagreeTextMain from '../../../../form/fields/DisagreeTextMain'

const AgreeHeaderBillItemForm = ({ supplyBillItemBd, setOpen }) => {

    const dispatch = useDispatch()

    const [data, setData] = useState(supplyBillItemBd ? {
        isAgreeLeadership: supplyBillItemBd.isAgreeLeadership,
        disagreeLeadershipText: supplyBillItemBd.disagreeLeadershipText,
    } : {}) // Дані з форми
        
    const [valid, setValid] = useState({}) // Валідація кожного поля
    const [loading, setLoading] = useState(false)

    const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми
    const [result, setResult] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        checkValid(valid, setIsValidForm)
    }, [valid])

    const save = (e) => {
        e.preventDefault()

        setError('')
        setLoading(true)

        agreeSupplyBillItemHeaderAPI({
            id: supplyBillItemBd.id,
            isAgreeLeadership: data.isAgreeLeadership,
            disagreeLeadershipText: data.disagreeLeadershipText,
        }).then(data => {
            if (data) {
                dispatch(editSupplyBillItem(data))
                dispatch(editSupplyBillsItemsAllItem(data))
                // dispatch(editSupplyBillItemIsAgreeLeadership({
                //     id: data.id,
                //     isAgreeLeadership: data.isAgreeLeadership
                // }))
                // dispatch(setSupplyBillsItemsAllIsAgreeLeadership({ // В окремому списку всіх позицій
                //     id: data.id,
                //     isAgreeLeadership: data.isAgreeLeadership
                // }))
            }

            setOpen(false)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

  return (
    <div className='myFormSimple'>
        <div>
            <p>
                Погодження позиції в рахунку керівником
            </p>
        </div>
        {
			formDataProductIsField('agree', 'supplyBillItemAgree') ?
				<AgreeSelectMain
					required={formDataProductRequiredField('agree', 'supplyBillItemAgree')}
					setValidate={e => updateValidate(setValid, 'isAgreeLeadership', e)}
					setValueForm={e => setValueForm(setData, 'isAgreeLeadership', e)}
					forciblyValue={
                        data && data.isAgreeLeadership === true ? true :
                        data && data.isAgreeLeadership === false ? false : ''
                    }
				/>
			: ''
        }
        {
			formDataProductIsField('disagreeText', 'supplyBillItemAgree') ?
				<DisagreeTextMain
					// required={formDataProductRequiredField('disagreeText', 'supplierAgree')}
					required={
                        data && (data.isAgreeLeadership === false || data.isAgreeLeadership === 'no') ? true  :
                        formDataProductRequiredField('disagreeText', 'supplyBillItemAgree')
                    }
					setValidate={e => updateValidate(setValid, 'disagreeLeadershipText', e)}
					setValueForm={e => setValueForm(setData, 'disagreeLeadershipText', e)}
					forciblyValue={data ? data.disagreeLeadershipText : ''}
                    className={data && (data.isAgreeLeadership === false || data.isAgreeLeadership === 'no') ? '' : 'hide'}
				/>
			: ''
        }

        <ErrorMessage
            error={error}
        />

        <MyButton
            size='md'
            onClick={save}
            disabled={!isValidForm || loading ? true : false}
        >
            Зберегти
        </MyButton>
    </div>
  )
}

export default AgreeHeaderBillItemForm